import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./draw-buffer-toolbar.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./draw-buffer-toolbar.scss?ngResource";
import { ChangeDetectionStrategy, Component, Injectable } from "@angular/core";
import * as geometryEngineAsync from "@arcgis/core/geometry/geometryEngineAsync";
import Graphic from "@arcgis/core/Graphic";
import { ApplicationMapSearchService } from "../../../../tabs/applications/application-search/shared/application-map-search.service";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
let DrawBufferToolbarComponent = class DrawBufferToolbarComponent {
    applicationMapSearchService;
    activeDrawTool;
    buffValue;
    buffType;
    constructor(applicationMapSearchService) {
        this.applicationMapSearchService = applicationMapSearchService;
    }
    addBufferWindow(mapView, sketch) {
        const bufferWindow = document.getElementsByTagName("app-buffer-toolbar")[0];
        reactiveUtils.when(() => mapView?.ready === true, () => {
            const widget = document.querySelectorAll(".esri-sketch.esri-widget");
            if (widget[0]) {
                widget[0].append(bufferWindow);
            }
            reactiveUtils.watch(() => sketch.activeTool, () => this.switchTollTip(sketch.activeTool));
        });
    }
    switchTollTip(event) {
        this.activeDrawTool = event;
        let tipText = "";
        switch (this.activeDrawTool) {
            case "point": {
                tipText = "<p>click to add a point</p>";
                break;
            }
            case "polyline": {
                tipText = "<p style=\"margin-bottom: 7px\">Click to start the drawing. Click again to continue drawing. Double-click to complete drawing</p>";
                break;
            }
            case "polygon": {
                tipText = "<p style=\"margin-bottom: 7px\">Click to start the drawing. Click again to continue drawing. Double-click to complete drawing</p>";
                break;
            }
            case "rectangle": {
                tipText = "<p style=\"margin-bottom: 7px\">Click to add shape, or press down to start and let go to finish </p>";
                break;
            }
            case "circle": {
                tipText = "<p style=\"margin-bottom: 7px\">Click to add shape, or press down to start and let go to finish </p>";
                break;
            }
            default: {
                tipText = "<p style=\"margin-bottom: 7px\">Please select a draw tool</p>";
            }
        }
        const toolTip = document.getElementById("toolTip");
        if (toolTip) {
            toolTip.innerHTML = tipText;
        }
    }
    addBuffer(event, gLayer, buffEnabled) {
        this.applicationMapSearchService.setBufferEnabled(buffEnabled);
        if (buffEnabled) {
            this.buffValue = +document.getElementById("buffVal").value;
            this.buffType = document.getElementById("buffType").value;
            if (event.state === "complete") {
                const simpleFillSymbol = {
                    type: "simple-fill",
                    color: [220, 20, 60, 0.5],
                    outline: {
                        style: "short-dash",
                        color: [255, 0, 0, 255],
                        width: 2
                    }
                };
                const toolGeo = event.graphic.geometry;
                geometryEngineAsync.geodesicBuffer(toolGeo, this.buffValue
                // @ts-ignore
                , this.buffType).then((buffer) => {
                    const bufferGraphic = new Graphic({
                        geometry: buffer,
                        symbol: simpleFillSymbol,
                        attributes: []
                    });
                    gLayer.add(bufferGraphic);
                    // inform the calling component that there is a buffer to consider
                    this.applicationMapSearchService.setGraphicsWithBuffer(bufferGraphic.geometry);
                });
            }
        }
        else {
            this.applicationMapSearchService.setGraphicsWithBuffer(null);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationMapSearchService }
    ];
};
DrawBufferToolbarComponent = __decorate([
    Injectable({
        providedIn: "root"
    }),
    Component({
        selector: "app-buffer-toolbar",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], DrawBufferToolbarComponent);
export { DrawBufferToolbarComponent };
